import styled from 'styled-components'
import { device, fonts } from '../../../styles/GlobalVariables'
import { globalStyles } from '../../ottGlobalStyles'

const MinuteLySlotGap = 80
const MinuteLySlotGapMob = 60
export const MinuteLyRailWrapper = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  padding: 0 ${globalStyles.gridPadding.mobile};
  margin-bottom: 60px;
  gap: ${MinuteLySlotGapMob}px;
  flex-direction: column;

  ${device.regular} {
    flex-direction: row;
    gap: ${MinuteLySlotGap}px;
    padding: 0 ${globalStyles.gridPadding.desktop};
  }
`

const MinuteLySlotAspect = 70
export const MinuteLySlotWrap = styled.div`
  flex: 0 0 ${MinuteLySlotAspect}%;
  display: flex;
  flex-direction: column;
`
export const MinuteLySlot = styled.div`
  display: flex;
  flex-direction: column;
  aspect-ratio: 16/9;
  width: 100%;
  background: #000;
  //background: #0d182d;
`

export const MinuteLyItemsWrap = styled.div`
  flex: 0 0 calc(${100 - MinuteLySlotAspect}% - ${MinuteLySlotGapMob}px);

  ${device.regular} {
    flex: 0 0 calc(${100 - MinuteLySlotAspect}% - ${MinuteLySlotGap}px);
  }
`

export const MinuteLyItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: 25px;

  a {
    text-decoration: none;
  }
`
export const MinuteLyItem = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
`

const thumbPrecent = 45
const thumbPrecentDesk = 50
export const MinuteLyItemThumb = styled.div`
  flex: 0 0 ${thumbPrecent}%;
  aspect-ratio: 16/9;
  overflow: hidden;
  border-radius: 10px;
  max-width: 230px;

  img {
    width: 100%;
    height: 100%;

    &.desktop {
      display: none;
    }

    &.mobile {
      display: block;
    }
  }

  ${device.regular} {
    flex: 0 0 ${thumbPrecentDesk}%;

    img {
      &.desktop {
        display: block;
      }

      &.mobile {
        display: none;
      }
    }
  }
`
export const MinuteLyItemTitleWrap = styled.div`
  flex: 0 0 calc(${100 - thumbPrecent}% - 20px);

  ${device.regular} {
    flex: 0 0 calc(${100 - thumbPrecentDesk}% - 20px);
  }
`
export const MinuteLyItemTopTitle = styled.div`
  display: inline-flex;
  padding: 0 8px;
  font-family: ${fonts.narkis};
  font-weight: 500;
  font-size: 16px;
  line-height: 120%;
  text-align: right;
  vertical-align: middle;

  ${device.regular} {
  }
`
export const MinuteLyItemTitle = styled.div`
  font-family: ${fonts.narkis};
  font-weight: 300;
  font-size: 18px;
  line-height: 120%;
  text-align: right;
  vertical-align: middle;
  color: white;
  text-decoration: none;

  ${device.regular} {
    font-weight: 400;
    font-size: 20px;
  }
`
export const MinuteLyTitle = styled.div`
  color: white;
  font-family: ${fonts.narkis};
  font-weight: 600;
  font-size: 24px;
  text-align: right;
  vertical-align: middle;
  padding-bottom: 0;
  margin-bottom: 12px;
  //border-bottom: 2px solid #5b5b5b;

  ${device.regular} {
    padding-bottom: 8px;
    font-size: 28px;
    margin-bottom: 20px;
  }
`
